// src/app/services/application.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

import { BorrowerApplication, SupplierApplication } from '../models/application.model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {


  private baseApiUrl = `${environment.apiUrl}/applications`;


  private jsonHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  });

  constructor(private http: HttpClient) { }

  /**
   * Retrieves an application based on role and ID.
   * @param role The role of the user ('borrower' or 'supplier').
   * @param id The ID of the application.
   * @returns An Observable of the application.
   */
  getApplication(role: 'borrower' | 'supplier', id: number): Observable<BorrowerApplication> {
    const url = `${this.baseApiUrl}/${role}/${id}`;
    return this.http.get<BorrowerApplication>(url, { headers: this.jsonHeaders }).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Updates an application based on role.
   * @param role The role of the user ('borrower' or 'supplier').
   * @param application The application data to update.
   * @returns An Observable of the update operation.
   */
  updateApplication(role: 'borrower' | 'supplier', application: BorrowerApplication | SupplierApplication): Observable<any> {
    const url = `${this.baseApiUrl}/${role}/submit`;
    return this.http.post(url, application, { headers: this.jsonHeaders }).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Handles HTTP errors.
   * @param error The HTTP error response.
   * @returns An Observable that throws an error message.
   */
  private handleError(error: HttpErrorResponse) {
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMsg = `An error occurred: ${error.error.message}`;
    } else {
      // Backend returned an unsuccessful response code
      errorMsg = error.error.message || 'Server returned an error.';
    }
    return throwError(() => errorMsg);
  }

}
